import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { createPersonalizationSearchString, getPersonalizationQueryParams } from 'personalization-lib/utils/urls/queryParams';
import { getAssetEditorUrl } from 'personalization-lib/utils/urls';
const useContentEditorUrl = ({
  assetCoordinates,
  strategyId
}) => {
  const {
    search: currentSearch
  } = useLocation();
  const newUrlSearch = useMemo(() => {
    const queryParams = getPersonalizationQueryParams(currentSearch);
    return createPersonalizationSearchString({
      fromCreate: queryParams.fromCreate,
      strategyId
    });
  }, [currentSearch, strategyId]);
  return assetCoordinates && getAssetEditorUrl(assetCoordinates, {
    search: newUrlSearch
  });
};
export default useContentEditorUrl;